import { render, staticRenderFns } from "./NotRegistered_4_2.vue?vue&type=template&id=98d033a0"
import script from "./NotRegistered_4_2.vue?vue&type=script&lang=js"
export * from "./NotRegistered_4_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports